import { DrawingTabEnum } from '@common/enums/drawing-tab.enum';
import type { RootState } from '@redux/store';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface ShapeState {
    // TODO: Moved as-is. Review usage to restructure the way it's done.
    selectedDrawingTab?: DrawingTabEnum;
}

const initialState: ShapeState = {
    selectedDrawingTab: DrawingTabEnum.ADD_PREDEFINED_SHAPE_TAB,
};

const shapeSlice = createSlice({
    name: 'shape',
    initialState,
    reducers: {
        resetSelectedDrawingTab: (state) => {
            state.selectedDrawingTab = initialState.selectedDrawingTab;
        },
        updateSelectedDrawingTab: (state, action: PayloadAction<DrawingTabEnum>) => {
            state.selectedDrawingTab = action.payload;
        },
        updateSelectedDrawingTabOnApplianceSelection: (state) => {
            state.selectedDrawingTab =
                state.selectedDrawingTab === DrawingTabEnum.SELECTED_SHAPE_TAB
                    ? initialState.selectedDrawingTab
                    : state.selectedDrawingTab;
        },
    },
});

export const { updateSelectedDrawingTab, updateSelectedDrawingTabOnApplianceSelection, resetSelectedDrawingTab } =
    shapeSlice.actions;

export const selectSelectedDrawingTab = ({ shape }: RootState): DrawingTabEnum | undefined => shape.selectedDrawingTab;

export default shapeSlice.reducer;
